export const concernedAreas = [
  // "Divorce & Child Custody",
  "Divorce",
  // "Family & Matrimonial",
  "Family",
  "Property",
  "Will",
  "Criminal",
  "Consumer Protection",
  "Cheque Bounce",
  "Cyber Crime",
  "Labour and Employment",
  // "Legal Notice",
  "Other Legal Problem",
  // "Business Legal Consultation",
  "Business",
];

export const divorceConcernedAreas = [
  // "Divorce & Child Custody",
  // "Family & Matrimonial",
  "Alimony and Maintenance",
  // "Domestic Violence",
];

export const propertyConcernedAreas = [
  // "Possession Delay",
  "Property Disputes",
  "RERA Act",
  "Other Property Issues",
];

export const businessConcernedAreas = [
  // "Company matters",
  "Corporate",
  // "Company (ROC) Compliance",
  // "Salary-Gratuity-PF",
  "Trademark and Copyrights",
  "Investment and Fundraise",
  "Direct Tax",
  "GST",
  "Debt Recovery",
  "NCLT matter",
  "Any other Business Legal matter",
];

// export const documentConcernedAreas = ["Document", "Registration"];

export const allConcernedAreas = [
  ...concernedAreas,
  ...propertyConcernedAreas,
  ...divorceConcernedAreas,
  ...businessConcernedAreas,
  // ...documentConcernedAreas,
];
